module.exports = __webpack_public_path__ + "static/media/img_internal_mobility_02.52f20f9b.png";